import './promise-polyfill'
import { app } from './app'
import Vue from 'vue'

// enable progressive web app support (with offline-plugin)
if (process.env.NODE_ENV === 'production') {
  require('./pwa')
}

// Custom global variables
window.localEnviroment = window.location.href.indexOf("localhost") > -1 || window.location.href.indexOf("dev.desenio") > -1;
window.appSettings = require('./settings');
window.modulesPath = '../../../build/modules/';
window.eventHub = new Vue()
window.$ = window.jQuery = require('jquery');


// Detect swipe
require('detect_swipe');

// Global functions
require('./globalFunctions')

// API
require('./api')

// FIlter mapping handler
require('./filterMapping')

// Import global components
import Loader from './components/Misc/Loader.vue'
import Modals from './components/Modals/Modal.vue' 
import Price from './components/Misc/Price.vue' 

// Use global components
Vue.component('loader', Loader)
Vue.component('modals', Modals)
Vue.component('price', Price)

var customMixins = require('./mixins.js');

if(customMixins.length){
	for (var i in customMixins){
		Vue.mixin(customMixins[i]);
	}
}

// PLugin
import VueLocalStorage from 'vue-localstorage'
Vue.use(VueLocalStorage)

// MOUNT VUE
window.vueInstance = app.$mount('#app')




// WEBPACK FOOTER //
// ./client/index.js